import classNames from "classnames";
import React, { FC, useContext } from "react";
import { useMedia } from "react-use";

import { LazyImg } from "@/components/Fetcher";
import { Icon } from "@/components/Icon";
import { UserContext } from "@/components/User";
import { MEDIA_SIZE_SM } from "@/core/media";
import { Flex, Img } from "@/eworkitComponents";

import { ICompanySectionProps } from "../types";
import { CompanyLogoEditButton } from "./CompanyLogoEditButton";

import "./_company-logo-section.scss";

interface ICompanyLogoSectionProps extends ICompanySectionProps {}

export const CompanyLogoSection: FC<ICompanyLogoSectionProps> = ({ record, onUpdate }) => {
  const isSmallScreen = useMedia(MEDIA_SIZE_SM);

  const User = useContext(UserContext);
  const isAdmin = User.hasCompanyAdminPrivileges();

  const baseClassName = "company-logo-section";
  const rootClass = classNames(baseClassName, {
    [`${baseClassName}--small-screen`]: isSmallScreen,
  });

  const placeholder = <Icon icon="company" className={`${baseClassName}__logo-placeholder`} color="grey4" />;

  return (
    <div className={rootClass}>
      <Flex direction="row" justify="space-between">
        <Flex className={`${baseClassName}__logo-container`} justify="flex-start" align="center" margin={["sm", false]}>
          {record.logo ? (
            record.logo.publicUrl ? (
              <div>
                <Img src={record.logo.publicUrl} className={`${baseClassName}__logo-container__logo`} />
              </div>
            ) : (
              <LazyImg key={record.logo.id} systemId={record.logo.systemId}>
                {({ payload, error }) => (
                  <>
                    {payload && payload.publicUrl ? (
                      <Img src={payload.publicUrl} className={`${baseClassName}__logo-container__logo`} />
                    ) : null}
                    {!payload && error ? placeholder : null}
                  </>
                )}
              </LazyImg>
            )
          ) : (
            placeholder
          )}
        </Flex>

        {isAdmin && (
          <Flex justify="flex-end" align="flex-start">
            <CompanyLogoEditButton
              size="lg"
              variant="clean"
              dialogProps={{
                source: record,
                onUpdate,
              }}>
              <Icon icon="edit" size="lg" color="grey2" />
            </CompanyLogoEditButton>
          </Flex>
        )}
      </Flex>
    </div>
  );
};
